/**
 * User roles api script class
 *
 * @package    Api
 * @author     Roman Kritskiy <rkritskiy@mindk.com>
 * @copyright  Copyright (c) 2010-2018 MindK (http://mindk.com). All rights reserved.
 * @license    http://mindk.com Commercial
 * @link       http://mindk.com
 */

export default class UserRolesApi {
    /**
     * Get user roles list
     *
     * @param filter
     * @returns {function(*): *}
     */
    static findUserRoles(filter) {
        return axios => axios.get('/users/roles', { filter });
    }

    /**
     * Get user roles history list
     *
     * @param filter
     * @returns {function(*): *}
     */
    static findUserRolesHistory(filter) {
        return axios => axios.get('/users/roles/history', { filter });
    }

    /**
     * Attach user role
     *
     * @returns {function(*)}
     */
    static storeUserRole(data) {
        return axios => axios.post('/users/roles', data);
    }

    /**
     * Detach user role
     *
     * @param id
     * @returns {function(*)}
     */
    static deleteUserRole(id) {
        return axios => axios.delete(`/users/roles/${id}`);
    }
}



// WEBPACK FOOTER //
// ./src/api/userRoles.js